<template>
  <v-card class="mx-auto" outlined v-if="itaterms.length">
    <div v-if="itaterms.length">
      <v-card-title>Esempi di termini  <span class="origin" >Dal database A4Edu</span>
</v-card-title>
      <div class="pr-4 pl-4">
      <table class="ttable" aria-label="Esempi di termini dal Db A4Edu">
        <thead>
          <tr>
            <th scope="col">Termine</th>
            <th scope="col">Lettura</th>
            <th scope="col">Traduzione</th>
          </tr>
        </thead>
        <tbody>
        <tr v-for="term in itaterms" :key="term.id">
          <td class="keb">
            {{ term.keb }}
          </td>
          <td class="reb">
            {{ term.reb }}
          </td>
          <td class="ita">
            {{ term.ita.join(", ") }}
          </td>
        </tr>
        </tbody>
      </table>
      </div>
    </div>
    <div v-else>
      <v-progress-circular indeterminate size="32"></v-progress-circular>
    </div>
  </v-card>
</template>

<script>
import Api from "@/services/Api";
export default {
  name: "TermExamples",
  data() {
    return {
      examples: "",
      terms: [],
      itaterms: [],
    };
  },

  mounted() {
    const literal = this.kanjiData.literal;
    Api()
      .get("/sapi/keb?kanji=" + encodeURIComponent(literal))
      .then((res) => {
        this.itaterms = res.data.result || [];
      });
  },
  props: ["kanjiData"],
};
</script>

<style scoped>
.ttable {
  border-collapse: collapse;
}
.ttable td {
  border: 1px solid #eeeeee;
  padding: 4px;
}
.ttable .keb {
  min-width: 120px;
}
.ttable .reb {
  min-width: 120px;
}
.origin {
  font-size:10px;
  color:#aaaaaa;
  vertical-align:middle;
  display:inline-block;
  margin-left:16px;
}

</style>
